<template>
  <div
    class="w-full max-w-[1339px] mx-auto mt-10 flex flex-col items-center tablet-h:border-t border-gray-200 tablet-h:pt-5 tablet-h:flex-row tablet-h:justify-between"
  >
    <DacrWordLogo class="w-[108px] mb-[13px] tablet-h:mb-0" />

    <div class="flex flex-col tablet-h:flex-row items-center gap-[18px]">
      <div
        class="font-primary font-medium text-[16px] leading-[24px] text-gray-800 text-center"
      >
        The new standard for copyright protection
      </div>

      <RouterLink to="/register">
        <UiButton :large="isMobileOrTablet">Get started</UiButton>
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { UiButton } from '@dacr/ui'
import DacrWordLogo from '@/assets/svg/other/DacrWordLogo.svg'
import { useDevice } from '@/shared/composables/useDevice'

const device = useDevice()
const isMobileOrTablet = computed(
  () => device.isMobile.value || device.isTabletVertical.value
)
</script>
